import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=5a52ae76"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=5a52ae76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports